module.exports = __webpack_public_path__ + "img/a-parreirinha-de-alfama.f04bb53c.jpg";